import React from "react";

const CardNumberFormat = ({ number, onlyNumber }) => {
  const separator = " - ";
  const chunkSize = 4;
  // تبدیل قطعی به رشته و حذف غیراعداد
  const numStr = String(number || "").replace(/\D/g, "");

  // فرمت کردن
  const formatted = numStr.replace(new RegExp(`(\\d{${chunkSize}})(?=\\d)`, "g"), `$1${separator}`);

  if (onlyNumber) {
    return formatted;
  } else return <span style={{ direction: "rtl", unicodeBidi: "plaintext" }}>{formatted}</span>;
};

export default CardNumberFormat;
